import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiEndpoints } from 'Utils/ApiEndpoints';

const baseUrl = process.env.REACT_APP_BASE_URL
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth?.authData?.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })(args, api, extraOptions);

    if (result?.error && result?.error.status === 401) {
        window.location.href = '/'
    }
    return result;
};

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['User'],
    endpoints: (builder) => ({
        getUserData: builder.query({
            query: ({ page, limit, type, searchData }) => ({
                url: `${apiEndpoints?.userGetUrl}?page=${page}&limit=${limit}&type=${type}&search_key=${searchData ?? ''}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        getUserDataDetails: builder.query({
            query: (userId) => ({
                url: `${apiEndpoints?.userDetailsUrl}?user_id=${userId}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        updateUserStatus: builder.mutation({
            query: (data) => ({
                url: apiEndpoints?.userStatusUrl,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['User'],
        }),
        getDashboardData: builder.query({
            query: () => ({
                url: `${apiEndpoints?.userDashboardUrl}`,
                method: 'GET',
            }),
        }),
        getAssignedMemberListing: builder.query({
            query: ({ page, limit, userId, role }) => ({
                url: `${apiEndpoints?.happcoachAssignedUsersList}?page=${page}&limit=${limit}&userId=${userId}&role=${role}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),

        getMemberDetailById: builder.query({
            query: ({ userId }) => ({
                url: `${apiEndpoints?.getMemberDetails}?userId=${userId}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),

        getEmpDropdown: builder.query({
            query: ({ user_id }) => ({
                url: `${apiEndpoints?.getEmpDropdown}?userId=${user_id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),

        getHCListByType: builder.query({
            query: ({ type }) => {
                if (!type) return null;
                return {
                    url: `${apiEndpoints?.getHCListByType}?type=${type}`,
                    method: 'GET',
                }
            },
        providesTags: ['User'],
    }),

    actionList: builder.query({
        query: ({ user_id, type }) => ({
            url: `${apiEndpoints?.actionCountUsersAdmin}?userId=${user_id}&type=${type}`,
            method: 'GET',
        }),
        providesTags: ['User'],
    })
})
});

export const {
    useGetUserDataQuery,
    useGetUserDataDetailsQuery,
    useUpdateUserStatusMutation,
    useGetDashboardDataQuery,
    useGetAssignedMemberListingQuery,
    useGetMemberDetailByIdQuery,
    useGetEmpDropdownQuery,
    useGetHCListByTypeQuery,
    useActionListQuery
} = userApi;